let Labels = {}

Labels.install = function (Vue) {
  Vue.prototype.$label = (key) => {
    return global.vesteda.labels[key] || 'LABEL MISSING'
  }
}

export default Labels
